import { ElMessage } from 'element-plus'

export interface HttpResponseInterface {
  code: number,
  msg?: string,
  data?: any
}

export interface AutoHandleMsgInterface {
  successMes?: string | undefined,
  failMes?: string | undefined,
}

export interface HandleResInterface {
  success: any,
  fail: any,
}


export interface HttpParamsInterface {
  [key: string]: any;
}

let lastFailMsg = '';
let lastFailTime = 0;

function shouldShowFail(msg: string): boolean {
  const now = Date.now();
  if (msg === lastFailMsg && now - lastFailTime < 500) return false;
  lastFailMsg = msg;
  lastFailTime = now;
  return true;
}

const handleRes = (res: HttpResponseInterface, options?: AutoHandleMsgInterface): HandleResInterface => {
  if (res.code === 200) {
    if (options && options.successMes) {
      ElMessage.success(options.successMes);
    }
    return {
      success: res.data || true,
      fail: undefined
    };
  }
  if (res.code === 401) {
    return {
      success: undefined,
      fail: res
    };
  }
  if (options && options.failMes && shouldShowFail(options.failMes)) {
    ElMessage.error(options.failMes);
  }
  return {
    success: undefined,
    fail: res
  };
};
export {
  handleRes
};
